const LanguageConstants = {
  LANGUAGE_OPTIONS: [
    { code: "af", label: "Afrikaans" },
    { code: "sq", label: "Albanian" },
    { code: "am", label: "Amharic" },
    { code: "ar", label: "Arabic" },
    { code: "hy", label: "Armenian" },
    { code: "az", label: "Azerbaijani" },
    { code: "eu", label: "Basque" },
    { code: "be", label: "Belarusian" },
    { code: "bn", label: "Bengali" },
    { code: "bs", label: "Bosnian" },
    { code: "bg", label: "Bulgarian" },
    { code: "ca", label: "Catalan" },
    { code: "ceb", label: "Cebuano" },
    { code: "ny", label: "Chichewa" },
    { code: "zh-CN", label: "Chinese" },
    { code: "co", label: "Corsican" },
    { code: "hr", label: "Croatian" },
    { code: "cs", label: "Czech" },
    { code: "da", label: "Danish" },
    { code: "nl", label: "Dutch" },
    { code: "en", label: "English" },
    { code: "eo", label: "Esperanto" },
    { code: "et", label: "Estonian" },
    { code: "tl", label: "Filipino" },
    { code: "fi", label: "Finnish" },
    { code: "fr", label: "French" },
    { code: "fy", label: "Frisian" },
    { code: "gl", label: "Galician" },
    { code: "ka", label: "Georgian" },
    { code: "de", label: "German" },
    { code: "el", label: "Greek" },
    { code: "gu", label: "Gujarati" },
    { code: "ht", label: "Haitian Creole" },
    { code: "ha", label: "Hausa" },
    { code: "haw", label: "Hawaiian" },
    { code: "iw", label: "Hebrew" },
    { code: "hi", label: "Hindi" },
    { code: "hmn", label: "Hmong" },
    { code: "hu", label: "Hungarian" },
    { code: "is", label: "Icelandic" },
    { code: "ig", label: "Igbo" },
    { code: "id", label: "Indonesian" },
    { code: "ga", label: "Irish" },
    { code: "it", label: "Italian" },
    { code: "ja", label: "Japanese" },
    { code: "jw", label: "Javanese" },
    { code: "kn", label: "Kannada" },
    { code: "kk", label: "Kazakh" },
    { code: "km", label: "Khmer" },
    { code: "ko", label: "Korean" },
    { code: "ku", label: "Kurdish (Kurmanji)" },
    { code: "ky", label: "Kyrgyz" },
    { code: "lo", label: "Lao" },
    { code: "la", label: "Latin" },
    { code: "lv", label: "Latvian" },
    { code: "lt", label: "Lithuanian" },
    { code: "lb", label: "Luxembourgish" },
    { code: "mk", label: "Macedonian" },
    { code: "mg", label: "Malagasy" },
    { code: "ms", label: "Malay" },
    { code: "ml", label: "Malayalam" },
    { code: "mt", label: "Maltese" },
    { code: "mi", label: "Maori" },
    { code: "mr", label: "Marathi" },
    { code: "mn", label: "Mongolian" },
    { code: "my", label: "Myanmar (Burmese)" },
    { code: "ne", label: "Nepali" },
    { code: "no", label: "Norwegian" },
    { code: "ps", label: "Pashto" },
    { code: "fa", label: "Persian" },
    { code: "pl", label: "Polish" },
    { code: "pt", label: "Portuguese" },
    { code: "pa", label: "Punjabi" },
    { code: "ro", label: "Romanian" },
    { code: "ru", label: "Russian" },
    { code: "sm", label: "Samoan" },
    { code: "gd", label: "Scots Gaelic" },
    { code: "sr", label: "Serbian" },
    { code: "st", label: "Sesotho" },
    { code: "sn", label: "Shona" },
    { code: "sd", label: "Sindhi" },
    { code: "si", label: "Sinhala" },
    { code: "sk", label: "Slovak" },
    { code: "sl", label: "Slovenian" },
    { code: "so", label: "Somali" },
    { code: "es", label: "Spanish" },
    { code: "su", label: "Sundanese" },
    { code: "sw", label: "Swahili" },
    { code: "sv", label: "Swedish" },
    { code: "tg", label: "Tajik" },
    { code: "ta", label: "Tamil" },
    { code: "te", label: "Telugu" },
    { code: "th", label: "Thai" },
    { code: "tr", label: "Turkish" },
    { code: "uk", label: "Ukrainian" },
    { code: "ur", label: "Urdu" },
    { code: "uz", label: "Uzbek" },
    { code: "vi", label: "Vietnamese" },
    { code: "cy", label: "Welsh" },
    { code: "xh", label: "Xhosa" },
    { code: "yi", label: "Yiddish" },
    { code: "yo", label: "Yoruba" },
    { code: "zu", label: "Zulu" },
    { code: "unset", label: "Undetermined" },
  ],
  UNDETERMINED_LABEL: "Undetermined",
};

export default LanguageConstants;
